
import React from "react";
import withWatchlist from 'src/components/filmwebid/withWatchlist';

import classNames from "classnames";
import Poster from 'src/components/posterrow/Poster';
import { Movie, StreamingContent } from 'src/lib/movieinfo/movieinfotypes';
import { IFilmomtale } from 'src/lib/types/Filmomtale';
import cssPosterStyles from "./CSSPoster.module.css";
import styles from "./PosterRow.module.css";

//#region [Props]
type PosterRowProps = {
    posterList?: null | undefined | (IFilmomtale | Movie | StreamingContent)[];
    max?: number;
    renderPlaceholders?: boolean;
    className?: string;
    optionalDisplay?: "year";
    longTitle?: boolean;
    hideKinoklubbBanner?: boolean;
};
//#endregion


//#region [Component]
export default function PosterRow({ posterList, max = 0, renderPlaceholders = false, className, optionalDisplay, longTitle = false, hideKinoklubbBanner = false }: PosterRowProps) {
    if ((posterList?.length ?? 0) === 0) {
        return null;
    }

    const list = posterList!.slice(0, max > 0 ? max : posterList?.length!);
    return <div className={classNames(className, styles.SRowContainer)}>
        {list?.map(film => <WLPoster key={(film as any)?._id ?? (film as any)?.mainVersionId ?? (film as any)?.id}
            film={film}
            sizes='(orientation: landscape) 203px, 25vw'
            wlcClassName={styles.ItemContainer}
            className={styles.SPoster}
            optionalDisplay={optionalDisplay}
            longTitle={longTitle}
            hideKinoklubbBanner={hideKinoklubbBanner}
        />)}
        {renderPlaceholders && (list?.length ?? 0) < max && max > 0 && times(max - (list?.length ?? 0), (idx) => <Placeholder key={idx} className={classNames(styles.ItemContainer, cssPosterStyles.CSSPoster)} />)}
    </div>;
}
//#endregion

//#region [Component]
type PlaceholderProps = {
    className?: string;
}

function Placeholder({ className }: PlaceholderProps) {
    return <div className={className}></div>
}
//#endregion

//#region [Styles]

const WLPoster = withWatchlist(Poster, "film");

//#endregion

function times(num: number, renderFunc: (index: number) => React.ReactNode): React.ReactNode | null {
    if (num > 0) {
        return Array.from(Array(num)).map((itm, index) => renderFunc(index));
    }
    return null;
}